import path from 'path';
import fs from 'fs';
import { major } from 'semver';

export const getAngularVersion = ({
	cwd,
	angularVersion: fromArgsAngularVersion,
	verbose
}: {
	cwd: string;
	angularVersion?: string;
	verbose?: (msg: string) => void;
}) => {
	const angularVersion = fromArgsAngularVersion ?? getAngularVersionFromPackageJson({ cwd });

	// Handle case where angularVersion is undefined or null
	if (!angularVersion) {
		if (verbose) {
			verbose('Could not get angular version from package.json. Falling back to 19');
		}
		return '19';
	}

	const cleanedAngularVersion =
		angularVersion.startsWith('^') || angularVersion.startsWith('~')
			? angularVersion.slice(1)
			: angularVersion;

	try {
		// If the version is just a major version number (like "20"), use it directly
		if (/^\d+$/.test(cleanedAngularVersion)) {
			return cleanedAngularVersion;
		}
		return major(cleanedAngularVersion).toString();
	} catch (error) {
		if (verbose) {
			verbose('Could not get angular version from package.json. Falling back to 19');
			verbose(error as string);
		}
		return '19';
	}
};

const getAngularVersionFromPackageJson = ({ cwd }: { cwd: string }) => {
	try {
		const packagePath = path.join(cwd, 'package.json');

		if (!fs.existsSync(packagePath)) {
			return undefined;
		}

		const packageJson = JSON.parse(fs.readFileSync(packagePath).toString());
		const dependencies = packageJson.dependencies || {};

		return dependencies['@angular/core'];
	} catch {
		return undefined;
	}
};
